import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createVouchersApi } from "../../../../services/dashboard/apiLecture";
import toast from "react-hot-toast";

export default function useCreateVouchers() {
    const queryClient = useQueryClient();
    const {
        mutate: createVouchers,
        isLoading: isCreating,
        error,
        data: vouchers,
    } = useMutation({
        mutationFn: ({
            grade,
            amount,
        }) => createVouchersApi({
            grade,
            amount,
        }),
        onSuccess: () => {
            toast.success("تم إنشاء الأكواد بنجاح");
            queryClient.invalidateQueries({
                queryKey: ["grade-vouchers"],
            });
        },

        onError: (error) => {
            toast.error(error.response.data.message);
        },
    });

    return { createVouchers, isCreating, error, vouchers };
}
